import { Close as CloseIcon } from '@mui/icons-material';
import { Fade, IconButton } from '@mui/material';
import React from 'react';
import { createPortal } from 'react-dom';
import {
  DialogContentBox,
  DialogOverlay,
  FlexColumnCenter,
} from '../../../components/LayoutBoxes';
import { dialogStyles } from '../styles/dialogStyles';

interface BaseDialogProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  showCloseButton?: boolean;
  centered?: boolean;
  portalToBody?: boolean;
}

export const BaseDialog: React.FC<BaseDialogProps> = ({
  open,
  onClose,
  children,
  showCloseButton = true,
  centered = false,
  portalToBody = false,
}) => {
  if (!open) return null;

  const dialogContent = (
    <Fade in={open} timeout={300}>
      <DialogOverlay
        data-dialog
        sx={
          portalToBody
            ? dialogStyles.viewportOverlay
            : centered
              ? dialogStyles.centeredOverlay
              : undefined
        }
      >
        <DialogContentBox
          data-dialog-content
          onClick={(e) => e.stopPropagation()}
          sx={centered ? dialogStyles.centeredContent : undefined}
        >
          {/* Close button */}
          {showCloseButton && (
            <IconButton
              onClick={onClose}
              sx={dialogStyles.closeButton}
              size='small'
            >
              <CloseIcon fontSize='small' />
            </IconButton>
          )}

          {/* Content */}
          <FlexColumnCenter sx={dialogStyles.contentPadding}>
            {children}
          </FlexColumnCenter>
        </DialogContentBox>
      </DialogOverlay>
    </Fade>
  );

  if (portalToBody && typeof document !== 'undefined') {
    return createPortal(dialogContent, document.body);
  }

  return dialogContent;
};
